<template>
    <div class="sign-up-payment">
        <div class="sign-up-payment__header">
            <h2 class="sign-up-payment__header-title">
                Escolha o melhor método de pagamento para você
            </h2>
            <p class="sign-up-payment__header-subtitle">
                Preencha os campos abaixo
            </p>
        </div>

        <div rounded="sm" class="sign-up-payment__content">
            <div class="sign-up-payment__content-payments">
                <vs-button v-for="payment in computedPayments" :key="payment.slug"
                           class="sign-up-payment__content-payments-button"
                           :class="{ 'sign-up-payment__content-payments-button--selected': payment.selected }"
                           :type="payment.selected ? 'filled' : 'border'"
                           @click="handlePaymentChoice(payment.slug)">
                    <span>{{ payment.name }}</span>
                    <AppIcon :color="payment.selected ? 'white' : ''" icon="mdi-check-circle-outline" size="large"/>
                </vs-button>
            </div>

            <div class="sign-up-payment__content-form">
                <slot/>
            </div>
        </div>
    </div>
</template>

<script>
import {defineComponent} from "vue"
import {trackBeginCheckout, trackAddPaymentInfo} from "@/helpers/gtmEvents";

import paymentsList from '@/constants/payments'
import AppIcon from '@/components/AppIcon'

export default defineComponent({
    name: 'SignUpPayment',

    components: {
        AppIcon
    },

    props: {
        plan: {
            type: Object,
            required: true
        },
        payment: {
            type: String,
            required: true
        },
    },

    data() {
        return {
            paymentChoosed: null
        }
    },

    computed: {
        computedPayments() {
            const payments = this.plan.method.split(',')

            return paymentsList
                .map((payment) => ({...payment, selected: payment.slug === this.paymentChoosed}))
                .filter((payment) => payments.includes(payment.slug))
        },
        computedGtmData() {
            return {
                ecommerce: {
                    currency: "BRL",
                    value: this.plan.planValue,
                    payment_type: this.paymentChoosed,
                    items: [{
                        item_id: this.plan.id,
                        item_name: this.plan.name,
                        discount: this.plan.discount,
                        item_brand: "Cartão Filóo",
                        price: this.plan.planValue,
                        quantity: 1
                    }]
                }
            };
        }
    },

    watch: {
        paymentChoosed(val) {
            if (val !== this.payment) {
                trackAddPaymentInfo(this.computedGtmData);
                this.$emit('setPaymentMethod', val)
            }
        },
        payment(newPayment) {
            this.paymentChoosed = newPayment
        }
    },
    methods: {
        handlePaymentChoice(paymentSlug) {
            this.paymentChoosed = paymentSlug;
            if (paymentSlug === 'cartao') {
                trackBeginCheckout(this.computedGtmData);
            }
        },
    },
    mounted() {
        this.paymentChoosed = this.payment
    }
})
</script>

<style lang="scss" scoped>
.sign-up-payment {
    background-color: #FFFFFF;
    border: 1px solid rgb(var(--vs-primary)) !important;
    border-radius: .75rem;
    padding: 1.25rem;

    &__header {
        &-title {
            font-size: 1.5rem;
            line-height: 2rem;
        }

        &-subtitle {
            font-size: 1rem;
            line-height: 1.5rem;
            margin-top: .25rem;
        }
    }

    &__content {
        margin: 1.25rem -0.5rem -0.5rem;
        padding: .5rem;
        width: calc(100% + 1rem);

        &-payments {
            align-items: center;
            display: flex;

            &-button {
                align-items: center;
                flex-grow: 1;
                height: 2.5rem;
                padding: 0 .75rem !important;
                color: rgb(var(--vs-primary));

                @media #{$md-and-up} {
                    flex-grow: 0;
                    padding: 0 1rem !important;
                }

                &::v-deep {
                    .vs-button-text {
                        align-items: center;
                        display: flex;
                        justify-content: center;
                    }
                }

                span,
                i {
                    color: inherit;
                }

                &:focus,
                &:active,
                &--selected {
                    background-color: #000000;
                    color: #000000;

                    span,
                    i {
                        color: #000000;
                    }
                }
            }
        }

        &-form {
            margin-top: 1.25rem;
        }
    }
}
</style>
